export const defaultLabels = {
  GAME_TITLE: "Co-op game",

  GAME_DEFAULTS_HOST_NEXT_BUTTON: "Next",
  GAME_DEFAULTS_HOST_PREVIOUS_BUTTON: "Previous",
  GAME_DEFAULTS_GUEST_READ_ALONG: "Please read along on the main screen",
  GAME_DEFAULTS_PLAYER_DRAWS_CARD: "draws card",
  GAME_DEFAULTS_PLAYER_DRAW_CARD: "Start the mission",
  GAME_DEFAULTS_PLAYER_READS_CARD: "read aloud",
  GAME_DEFAULTS_PLAYER_CONFIRMS_OPTION: "Confirm",

  GAME_RESOURCE_NAME: "Energy",
  GAME_RESOURCE_UNIT: "%",
  GAME_RESOURCE_MY_RESOURCE_LABEL: "My energy",

  GAME_LOGIN_HOST_TITLE: "Login",
  GAME_LOGIN_HOST_DESCRIPTION:
    "One by one, scan the QR code to join the game. When ready, click next.",
  GAME_LOGIN_HOST_MAX_PLAYERS_REACHED:
    "Room is full. Click next to start the game.",
  GAME_LOGIN_HOST_PLAYERS_LOGGED_IN: "players logged in",
  GAME_LOGIN_GUEST_WAIT_MESSAGE: "Please wait until the game starts",

  GAME_INTRO_HOST_FALLBACK_TITLE: "Game intro",
  GAME_INTRO_HOST_FALLBACK_DESCRIPTION: "Game intro description",
  GAME_INTRO_HOST_START_GAME_BUTTON: "Start game",
  GAME_INTRO_HOST_SKIP_INTRO_BUTTON: "Skip intro",
  GAME_INTRO_GUEST_WELCOME_MESSAGE: "Welcome!",

  GAME_OUTRO_HOST_FALLBACK_TITLE: "Game outro",
  GAME_OUTRO_HOST_FALLBACK_DESCRIPTION: "Game outro description",
  GAME_OUTRO_END_GAME_BUTTON: "Play again",
  GAME_OUTRO_HOST_RESULTS_BUTTON: "Results",
  GAME_OUTRO_GUEST_OUTRO_MESSAGE: "Congratulations!",
  GAME_OUTRO_HOST_RESULTS_TITLE: "Results",

  ROUND_INTRO_HOST_FALLBACK_TITLE: "Rounds intro",
  ROUND_INTRO_HOST_FALLBACK_DESCRIPTION: "Rounds intro description",
  ROUND_INTRO_LAST_SLIDE_BUTTON: "Next",

  ROUND_REDISTRIBUTE_HOST_TITLE: "Redistribute your energy",
  ROUND_REDISTRIBUTE_HOST_DESCRIPTION:
    "Press the + button on your personal screen to give 10% of your energy to the team each time. Press the + button on the dashboard below the selected team member to give 10% of the team to that person each time.",
  ROUND_REDISTRIBUTE_HOST_CONFIRM_BUTTON: "Confirm and continue",
  ROUND_REDISTRIBUTE_HOST_RESET_BUTTON: "Reset redistribution",
  ROUND_REDISTRIBUTE_GUEST_BUTTON_TITLE: "Give energy to your team",
  ROUND_REDISTRIBUTE_GUEST_BUTTON_EXPLANATION:
    "Using this button, you give 10% of energy to the team. From there, you can distribute it to your team members if desired. Before the distribution becomes final, it needs to be confirmed on the main screen.",

  ROUND_OUTRO_HOST_FALLBACK_TITLE: "Rounds outro",
  ROUND_OUTRO_HOST_FALLBACK_DESCRIPTION: "Rounds outro description",
  ROUND_OUTRO_LAST_SLIDE_BUTTON: "Next",
}

export const defaultLabelsNl = {
  GAME_TITLE: "Co-op game",

  GAME_DEFAULTS_HOST_NEXT_BUTTON: "Volgende",
  GAME_DEFAULTS_HOST_PREVIOUS_BUTTON: "Vorige",
  GAME_DEFAULTS_GUEST_READ_ALONG: "Lees mee op het hoofdscherm",
  GAME_DEFAULTS_PLAYER_DRAWS_CARD: "trekt een kaart",
  GAME_DEFAULTS_PLAYER_READS_CARD: "leest voor",
  GAME_DEFAULTS_PLAYER_CONFIRMS_OPTION: "Bevestig",

  GAME_RESOURCE_NAME: "Energie",
  GAME_RESOURCE_UNIT: "%",
  GAME_RESOURCE_MY_RESOURCE_LABEL: "Mijn energie",

  GAME_LOGIN_HOST_TITLE: "Login",
  GAME_LOGIN_HOST_DESCRIPTION:
    "Scan één voor één onderstaande QR-code met je smartphone.",
  GAME_LOGIN_HOST_MAX_PLAYERS_REACHED:
    "Max aantal deelnemers bereikt, klik op volgende om de game te starten.",
  GAME_LOGIN_HOST_PLAYERS_LOGGED_IN: "deelnemers ingelogd",
  GAME_LOGIN_GUEST_WAIT_MESSAGE: "Wacht tot het spel start.",

  GAME_INTRO_HOST_FALLBACK_TITLE: "Game intro",
  GAME_INTRO_HOST_FALLBACK_DESCRIPTION: "Game intro description",
  GAME_INTRO_HOST_START_GAME_BUTTON: "Start game",
  GAME_INTRO_HOST_SKIP_INTRO_BUTTON: "Skip intro",
  GAME_INTRO_GUEST_WELCOME_MESSAGE: "Welkom!",

  GAME_OUTRO_HOST_FALLBACK_TITLE: "Game outro",
  GAME_OUTRO_HOST_FALLBACK_DESCRIPTION: "Game outro description",
  GAME_OUTRO_END_GAME_BUTTON: "Speel nog eens",
  GAME_OUTRO_HOST_RESULTS_BUTTON: "Download resultaten",
  GAME_OUTRO_GUEST_OUTRO_MESSAGE: "Proficiat!",
  GAME_OUTRO_HOST_RESULTS_TITLE: "Resultaten",

  ROUND_INTRO_HOST_FALLBACK_TITLE: "Rounds intro",
  ROUND_INTRO_HOST_FALLBACK_DESCRIPTION: "Rounds intro description",
  ROUND_INTRO_LAST_SLIDE_BUTTON: "Volgende",

  ROUND_REDISTRIBUTE_HOST_TITLE: "Herverdeel jullie energie",
  ROUND_REDISTRIBUTE_HOST_DESCRIPTION:
    "Druk op de “+” knop op je persoonlijk scherm om telkens 10% van jouw energie aan het team te geven. Druk op de “+” knop van het dashboard onder het gekozen teamlid om telkens 10% van het team aan die persoon te geven.",
  ROUND_REDISTRIBUTE_HOST_CONFIRM_BUTTON: "Bevestig en ga verder",
  ROUND_REDISTRIBUTE_HOST_RESET_BUTTON: "Reset herverdeling",
  ROUND_REDISTRIBUTE_GUEST_BUTTON_TITLE: "Geef energie aan je team",
  ROUND_REDISTRIBUTE_GUEST_BUTTON_EXPLANATION:
    "Via deze knop geef je 10% energie aan de rakket. Van daar uit kan je eventueel verdelen naar je teamleden. Voor de verdeling definitief wordt, moet nog bevestigd worden op het hoofdscherm.",

  ROUND_OUTRO_HOST_FALLBACK_TITLE: "Rounds outro",
  ROUND_OUTRO_HOST_FALLBACK_DESCRIPTION: "Rounds outro description",
  ROUND_OUTRO_LAST_SLIDE_BUTTON: "Volgende",
}
